import { makeStyles, createStyles } from '@material-ui/core/styles';
import background from 'images/BG-signup.jpg';
import styled from 'styled-components';

export const StyledWrapper = styled.div`
  padding-top: 120px;
  padding-bottom: 60px;
  background-image: url(${background});
  background-size: 2556px 1600px;
  background-position: 5% 12%;
`;
export const useLayoutStyles = makeStyles(() =>
  createStyles({
    paper: {
      margin: 'auto',
      marginTop: '120px',
      maxWidth: 670,
    },
    box: {
      minHeight: '95vh',
    },
  }),
);
